import {certificateElementCapability} from "./certificateElementCapability";
import GridCertificateElement from "./gridCertificateElement";
import Certificate from "./certificate";
import BaseCertificateElement from "./baseCertificateElement";
import {IDimensions} from "~/interfaces/certificateBuilderInterfaces";
import {CertificateSize} from "../enums/certificateSize";
import {CertificateOrientation} from "../enums/certificateOrientation";
import Vue from "vue";
import {HorizontalAlignment, VerticalAlignment} from "~/enums/certificates/alignment";
import GridCellCertificateElement from "./gridCellCertificateElement";
import AdaptiveLayoutSection from "./adaptiveLayoutSection";
import {certificateElementType} from "~/enums/certificateElementType";

export default class DynamicModeCertificateElement extends BaseCertificateElement {
  //Page certificate element temporarily here until sections are implemented
  // @ts-ignore
  parent:  GridCertificateElement | DynamicModeCertificateElement  | AdaptiveLayoutSection | GridCellCertificateElement
  vertical_alignment: VerticalAlignment
  horizontal_alignment: HorizontalAlignment
  is_repeatable: boolean;
  repeatable_input_id: string

  //TODO: Here until sections get implemented
  get marginInPixels(): number{
    return this.certificate.marginInPixels
  }

  get repeatableId(): string | null {
    if (this.isLayoutElementContainer) {
      return this.repeatable_input_id
    } else {
      return this.layoutElementContainer.repeatable_input_id
    }
  }

  get section(): AdaptiveLayoutSection {
    if (this.parent instanceof AdaptiveLayoutSection) {
      return this.parent;
    } else {
      return this.parent.section;
    }
  }

  get isConfiguredToRepeatableInput(): boolean {
    //overwritten
    return false
  }

  set y(val: number){
    //  Do nothing just needed for vue-draggable-resizable component
  }
  get y(): number{
    //adjust by one to account for border padding from grid cell style
    return 1
  }
  //renderCoord methods are used to ensure the same interface as static certificate elements
  get renderY(): number{
    return this.y
  }
  get renderX(): number{
    return this.x
  }

  set x(val: number){
  //  Do nothing just needed for vue-draggable-resizable component
  }


  get x(): number {
    const parent: GridCellCertificateElement = this.parent as GridCellCertificateElement;
    switch (this.horizontal_alignment) {
      case HorizontalAlignment.Left:
        return 0;
      case HorizontalAlignment.Middle:
        return (parent.cellWidth - this.width) / 2;
      case HorizontalAlignment.Right:
        return parent.cellWidth - this.width;
    }
  }

  //TODO: Here until sections get implemented
  get dimensions(): IDimensions {
    const scale = Certificate.cardScale;
    let width = 0, height = 0;
    let basePixels;
    if (this.certificate.size === CertificateSize.Card) {
      basePixels = [Certificate.cardPixelDimensions.long * scale, Certificate.cardPixelDimensions.short * scale];
    } else {
      basePixels = [Certificate.letterPixelDimensions.long, Certificate.letterPixelDimensions.short];
    }
    this.certificate.orientation === CertificateOrientation.Landscape ? [width, height] = basePixels : [height, width] = basePixels;
    return { width, height };
  }


  get isLayoutElementContainer(): boolean{
    return this.can(certificateElementCapability.layoutAble)
  }

  get isInsertElement(): boolean{
    return [certificateElementType.DynamicModeText, certificateElementType.DynamicModeDynamicImage, certificateElementType.DynamicModeImage, certificateElementType.DynamicModeDynamicList].includes(this.type)
  }

  get firstEmptyCell() {
    //Overwritten
    return this.layoutElementContainer.firstEmptyCell
  }

  get layoutElementContainer(): DynamicModeCertificateElement{
    if (this.isLayoutElementContainer){
      return this
    }else{
      return (this.parent as DynamicModeCertificateElement).layoutElementContainer
    }
  }

  get isLast(): boolean {
    const nextSortOrder = (<Certificate | GridCertificateElement>this.parent).nextSortOrderFor(this.rootName)
    return nextSortOrder !== null && this.sort_order ===  nextSortOrder - 1;
  }

  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  clearRepeatableInputs() {
    //  Overwritten where needed
  }

  moveUp(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.parent.elementHandler.updateElementPositions(this.parent, this, this.sort_order);

      Vue.nextTick(()=>{
        this.select()
      })
    }
  }

  moveDown(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.parent.elementHandler.updateElementPositions(this.parent, this, this.sort_order);
      Vue.nextTick(()=>{
        this.select()
      })
    }
  }
}